import { map, filter } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';

import { BreadcrumbService } from '../../../services/common/breadcrumb.service';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.css'],
})
export class BreadcrumbsComponent implements OnInit {
  /**
   * breadcrumbs list
   */
  breadcrumbs: Array<Array<string>> = [['/', 'Home', 'true']];

  /**
   * Constructor
   * @param {BreadcrumbService} private breadcrumbService Service to get breadcrumbs from rails server
   * @param {ActivatedRoute}    private route             Angular route with current route info and params
   * @param {Router}            private router            Angular router to perform navigation
   */
  constructor(private breadcrumbService: BreadcrumbService, private route: ActivatedRoute, private router: Router) {}

  /**
   * Called on component initialization
   */
  ngOnInit() {
    if (this.route.snapshot.data.name) this.breadcrumbService.create([this.route.snapshot.url, this.route.snapshot.data.name]).then((response_json) => (this.breadcrumbs = response_json.breadcrumbs));
    this.refreshBreadcrumbs();
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        map(() => this.route),
        map((route) => {
          while (route.firstChild) route = route.firstChild;
          return route;
        }),
        filter((route) => route.outlet === 'primary')
      )
      .subscribe((event) => {
        this.refreshBreadcrumbs();
      });
  }

  private refreshBreadcrumbs() {
    this.breadcrumbService.index().then((response_json) => {
      if (response_json && response_json.breadcrumbs && this) this.breadcrumbs = response_json.breadcrumbs;
    });
  }
}
